import instance from '@/services/repository';

const resource = '/machinery/Rentals';

export default {
    lookup(options: any, onlyActive: boolean, machineryId?: string, projectId?: string) {
        const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        if (!machineryId) {
            machineryId = '';
        }
        if (!projectId) {
            projectId = '';
        }

        return instance
            .post(`${resource}/lookup?machineryId=${machineryId}&projectId=${projectId}&onlyActive=${onlyActive}`,
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data' },
                });
    },
    getSingle(id: string) {
        return instance.get<IMachineryRentalDto>(`${resource}/${id}`);
    },
    downloadContract(id: string) {
        return instance
            .get<Blob>(`${resource}/${id}/Contract`, { responseType: 'blob' });
    },
    downloadContractEnding(id: string) {
        return instance
            .get<Blob>(`${resource}/${id}/Contract-ending`, { responseType: 'blob' });
    },
    create(payload: IMachineryRentalCreateCommand) {
        return instance.post<IMachineryRental>(`${resource}`, payload);
    },
    update(payload: IMachineryRentalUpdateCommand) {
        return instance.put<IMachineryRental>(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    getTemplates() {
        return instance.get<IMachineryTemplate[]>(`${resource}/templates`);
    },
    generateContract(payload: IMachineryGenerateContractCommand) {
        return instance.post<any>(`${resource}/generateContract`, payload);
    },
    generateContractEnding(payload: IMachineryGenerateContractCommand) {
        return instance.post<any>(`${resource}/generateContractEnding`, payload);
    },
    getImages(id: string) {
        return instance.get<IMachineryRentalImage[]>(`${resource}/${id}/images`);
    },
    uploadImage(id: string, file: Blob, filename: string) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('image', file, filename);
        return instance.post(`${resource}/${id}/Image`,
            formDataToUpload, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    uploadFileChunk(projectId: string, path: string, file: any, metadata: any) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('file', file);
        formDataToUpload.append('path', path);
        formDataToUpload.append('chunkMetadata', metadata);
        return instance.post(`${resource}/${projectId}/files/uploadChuncks`, formDataToUpload, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    UploadSignedContract(id: string, payload: IUploadChunkDto) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('file', payload.file, payload.metaData.fileName);
        formDataToUpload.append('path', '');
        formDataToUpload.append('metaData[index]', '' + payload.metaData.index);
        formDataToUpload.append('metaData[totalCount]', '' + payload.metaData.totalCount);
        formDataToUpload.append('metaData[fileSize]', '' + payload.metaData.fileSize);
        formDataToUpload.append('metaData[fileName]', '' + payload.metaData.fileName);
        formDataToUpload.append('metaData[fileType]', '' + payload.metaData.fileType);
        formDataToUpload.append('metaData[fileGuid]', '' + payload.metaData.fileGuid);
        return instance.post(`${resource}/${id}/SignedContract`,
            formDataToUpload, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    RemoveSignedContract(id: string) {
        return instance.delete(`${resource}/${id}/SignedContract`);
    },
    sign(id: string, file: Blob) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('image', file);
        return instance.post(`${resource}/${id}/Sign`,
            formDataToUpload, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    updateImage(command: IMachineryRentalImageUpdateCommand) {
        return instance.put(`${resource}/${command.rentalId}/Image/${command.filename}`, command);
    },
    deleteImage(id: string, filename: string) {
        return instance.delete(`${resource}/${id}/Image/${filename}`);
    },
    generateInvoice(payload: IMachineryRentalGenerateInvoiceCommand) {
        return instance.post<any>(`${resource}/GenerateInvoice`, payload);
    },
};
